export const AdSetBudgetDecreasedIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M15.5 5.5L21.5 5.5" stroke="#E0295E" strokeWidth="1.5" strokeLinecap="round" />
        <path
            d="M17.8732 10.9841C18.0832 12.6254 17.7791 14.2914 17.0028 15.7526C16.2265 17.2138 15.0163 18.3984 13.5388 19.1432C12.0612 19.888 10.3891 20.1563 8.75274 19.9111C7.11637 19.666 5.59626 18.9196 4.4018 17.7745C3.20734 16.6295 2.3973 15.1423 2.08326 13.5178C1.76922 11.8932 1.96664 10.2113 2.64831 8.70357C3.32998 7.19589 4.46238 5.93666 5.8895 5.09935C7.31663 4.26204 8.96828 3.88784 10.6169 4.02829"
            stroke="#E0295E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.4149 10.0106C12.4149 9.07447 11.4787 7.90426 10.0745 7.90426M10.0745 7.90426C8.67021 7.90426 7.5 8.84043 7.5 10.0106C7.5 11.1809 8.20213 12.117 10.0745 12.117C11.9468 12.117 12.4149 13.0532 12.4149 14.2234C12.4149 15.3936 11.2447 16.3298 9.84043 16.3298M10.0745 7.90426V6.5M7.5 14.2234C7.5 15.1596 8.43617 16.3298 9.84043 16.3298M9.84043 16.3298V17.5"
            stroke="#E0295E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default AdSetBudgetDecreasedIcon
